import React from 'react';
import {
  Row,
  Col,
  Input,
  Typography,
  Table,
  Button,
  DatePicker,
  Select,
  Form,
  Skeleton,
  Result
} from 'antd';
import {
  FaSearch,
} from "react-icons/fa"; //Font Awesome 5
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';
import FormCreateAttendance from './components/FormCreateAttendance';
// import DeletePopupButton from './components/DeletePopupButton';
// import EditFormModal from './components/EditFormModal';
// import AddFormModal from './components/AddFormModal';
const attendanceStatus = [
  { label: 'attend', value: true },
  { label: 'absent', value: false },
]
const columns = [
  {
    title: 'Date',
    dataIndex: 'check_date',
    key: 'check_date',
    // render: (text, _) => dayjs(text).format('DD-MM-YYYY')
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/attendance/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {dayjs(text).format('DD-MM-YYYY')}
      </Button>
  },
  {
    title: 'Time',
    dataIndex: 'begin_time',
    key: 'begin_time',
    // render: (text, _) => dayjs(text).format('DD-MM-YYYY')
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/attendance/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {`${record.begin_time} - ${record.end_time}`}
      </Button>
  },
  {
    title: 'Course',
    dataIndex: 'product',
    key: 'product',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/attendance/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text.name ?? "-"}
      </Button>
  },
  {
    title: 'Description',
    dataIndex: 'description',
    key: 'description',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/attendance/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text}
      </Button>
  },
  {
    title: 'Created by',
    dataIndex: 'user',
    key: 'user',
    render: (text, record) =>
      <Button
        type='text'
        href={`/admin/attendance/${record._id}`}
        style={{
          width: "100%",
          background: 'none',
          textAlign: 'left'
        }}>
        {text.fname_th}
      </Button>
  },
  // {
  //   title: '',
  //   dataIndex: 'action',
  //   key: 'action',
  //   render: (_, record) => (
  //     <Space size="small">
  //       <EditFormModal data={record} />
  //       <DeletePopupButton data={record} />
  //     </Space>
  //   ),
  // }
]

function List() {
  const [form] = Form.useForm();
  const redirect = useNavigate();
  const attendanceQuery = useQuery({ queryKey: ['/api/attendance/'] })
  const activeCourseQuery = useQuery({ queryKey: ['/api/attendance/getActiveCourse'] })
  if (
    attendanceQuery.isLoading
    || activeCourseQuery.isLoading
  ) {
    return <Skeleton active />
  }

  if (
    attendanceQuery.isError
    || activeCourseQuery.isError
  ) {
    return <Result status="error"
      title={
        attendanceQuery.error.message
        || activeCourseQuery.error.message
      } />
  };

  const onSearch = () => {

    form
      .validateFields()
      .then(values => {
        
        let searchText = ""
        if (!!values.check_date) {
          searchText += `check_date=${dayjs(values.check_date).toISOString()}&`
        }
        if (!!values.course) {
          searchText += `course=${values.course}&`
        }
        if (!!values.q) {
          searchText += `q=${values.q}`
        }
        if (!!values.status || values.status !== undefined) {
          searchText += `status=${values.status}`
        }
        redirect(`/admin/attendance/search?${searchText}`)
      })
      .catch(err => {
        console.log(err)
      })

  }

  // console.log('attendanceQuery.data :', attendanceQuery.data);
  // console.log('activeCourseQuery.data :', activeCourseQuery.data);

  return (
    <div >
      <Row gutter={[16, 16]}>
        <Col xs={24}>
          <Row >
            <Col>
              <Typography.Title level={3}>
                Attendance
              </Typography.Title>
            </Col>
            <Col flex={1} />
            <Col>
              <FormCreateAttendance courses={activeCourseQuery.data} />
            </Col>
          </Row>
        </Col>
        <Col xs={24}>
          <Form
            form={form}
            name='searchOrders'
          >
            <Row justify='space-between' gutter={[8, 0]}>
              <Col xs={24} md={6}>
                <Form.Item
                  label=""
                  name="check_date"
                >
                  <DatePicker style={{ width: "100%" }} format={'DD-MM-YYYY'} />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  label=""
                  name="course"
                >
                  <Select
                    placeholder="Select Course"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                  >
                    {
                      activeCourseQuery.data.map(course => <Select.Option key={course._id} value={course._id}>{course.name}</Select.Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
              <Col xs={24} md={6}>
                <Form.Item
                  label=""
                  name="status"
                >
                  <Select
                    placeholder="Status"
                    showSearch
                    optionFilterProp="children"
                    allowClear
                  >
                    {
                      attendanceStatus.map(st => <Select.Option key={st.label} value={st.value}>{st.label}</Select.Option>)
                    }
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[8, 0]}>
              <Col flex={1} >
                <Form.Item label="" name="q">
                  <Input placeholder="Search Student name, Student ID or Phone" />
                </Form.Item>
              </Col>
              <Col>
                <Button
                  type='primary'
                  icon={<FaSearch />}
                  onClick={onSearch}
                  style={{ width: '100%' }}
                >Search</Button>
              </Col>
            </Row>
          </Form>
        </Col>
        <Col xs={24}>
          <Table
            rowKey={(record) => record._id}
            columns={columns}
            dataSource={attendanceQuery.data}
            scroll={{
              x: 1200,
            }}
          />
        </Col>
      </Row>
    </div>
  )
}

export default List